import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { useSupplierOfferPublishMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { SUPPLIER_OFFER_SOURCE, SupplierOfferSourceValueType } from 'models/SupplierOffer';

export const usePublishCalculationModal = (
  onClose: () => void,
  source?: SupplierOfferSourceValueType,
  entityId?: string
) => {
  const { handleError, handleSuccess } = useNotificationMessages();
  const navigate = useNavigate();

  const [supplierOfferPublish] = useSupplierOfferPublishMutation();

  const onConfirm = useCallback(
    async (recordId: string | undefined) => {
      if (recordId) {
        try {
          const { data, error } = await supplierOfferPublish(recordId);
          if (data?.success) {
            handleSuccess('Supplier Offer was successfully published.');
            switch (source) {
              case SUPPLIER_OFFER_SOURCE.PO_ADD:
                navigate(ADMIN_ROUTES.purchaseOrder.create);
                return;
              case SUPPLIER_OFFER_SOURCE.PO_DETAILS:
                navigate(`${ADMIN_ROUTES.purchaseOrder.view}/${entityId}/general`);
                return;
              case SUPPLIER_OFFER_SOURCE.PR_DETAILS:
                navigate(`${ADMIN_ROUTES.purchaseRequest.view}/${entityId}/supplier-offers`);
                return;
              case SUPPLIER_OFFER_SOURCE.MAIN:
                navigate(ADMIN_ROUTES.supplierOffer.list);
                return;
            }
            onClose();
          } else {
            handleError(error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [handleSuccess, handleError, supplierOfferPublish, navigate, source, entityId, onClose]
  );

  return {
    onConfirm,
  };
};
